// extracted by css-extract-rspack-plugin
export default {"card":"Nm0NBVneX7Mv8FKW","links":"Tb3O2EFssrEOj_FR","pimActivation":"IVqy9d5R8onbjIy9","showAllToggle":"s9bqwJ8i0hEYWNcZ","label":"aze0ub02li4FwfRE","link":"d8azWtR5CMIxzT3E"};